/**
 * 工程のチェックリスト
 */
export class SubTask {
  taskId?: number;
  name: string = "";
  done: boolean = false;
  created: Date = new Date();
  dueDate: string = "";

  public constructor(params: SubTaskInput = {}) {
    if (params.taskId) this.taskId = params.taskId;
    if (params.name) this.name = params.name;
    if (params.done) this.done = params.done;
    if (params.created) this.created = params.created;
    if (params.dueDate) this.dueDate = params.dueDate;
  }
}

export interface SubTaskInput {
  taskId?: number;
  name?: string;
  done?: boolean;
  created?: Date;
  dueDate?: string;
}
